import React, { useContext, useEffect, useState } from 'react';
import RegisterNewClubInput from './RegisterNewClubInput/RegisterNewClubInput';
import Searching from './Searching/Searching';
import ClubList from '../ClubList/ClubList';
import Button from '../ClubRegistrationButton/ClubRegistrationButton';
import Styles from './RegisterNewClub.module.scss';
import { LocalizationContext } from '../../context/localizationContext';
import APIClient from '../../helpers/APIClient';
import { clubsContext } from '../../context/clubsContext';

const RegisterNewClub = () => {
  const [searching, setSearching] = useState(false);
  const [serialSearched, setSerialSearched] = useState(null);
  const [error, setError] = useState(null);
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { button, registerNewClub } = localizationState.localization;
  const clubContext = useContext(clubsContext);
  const { state, dispatch } = clubContext;
  const { searchedClubs, selectedClubs } = state;

  const handleSerialSearch = () => {
    if (serialSearched) {
      setError(null);
      setSearching(true);
      APIClient.validateSerial(serialSearched, (status, response) => {
        setSearching(false);
        if (status === 200) {
          dispatch({
            type: 'SET_SEARCHED_AND_SELECTED_CLUBS',
            searchedClubs: response.data,
            selectedClubs,
          });
        } else if (status === 400) {
          const errorStringReplace = registerNewClub?.noData?.replace(
            '{serial_placeholder}',
            serialSearched
          );
          setError(errorStringReplace);
        } else {
          setError(registerNewClub?.serverError);
        }
      });
    }
  };

  const showSerialInputOrClubs = () => {
    if (searchedClubs?.length) {
      return <ClubList registered={false} searchedClubs={searchedClubs} />;
    }

    return (
      <div className={Styles.registerNewClubContainer}>
        <RegisterNewClubInput
          setSerialSearched={setSerialSearched}
          handleSerialSearch={handleSerialSearch}
        />
        <Button label={button.submit} onClick={handleSerialSearch} />
        {error && (
          <div className={Styles.errorMessage}>
            <div
              dangerouslySetInnerHTML={{
                __html: error ?? '',
              }}
            ></div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      {searching ? (
        <Searching serialSearched={serialSearched} />
      ) : (
        showSerialInputOrClubs()
      )}
    </div>
  );
};

export default RegisterNewClub;
